
import { Component, computed, inject } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { NavItems } from "../../nav.items";
import { AuthStore } from "../../../auth/persistence/auth.store";
import { RegionService } from "../../../regions/region.service";

@Component({
    selector: "app-nav",
    imports: [MatIcon, RouterLink, RouterLinkActive],
    templateUrl: "./nav.component.html",
})
export class NavComponent {
    private _authStore = inject(AuthStore);
    
    public regionService = inject(RegionService);

    public items = computed(() => NavItems.filter((item) => this._authStore.canAccess(item.route[1])));

    public logout(): void {
        this._authStore.logout();
    }
}
